<script setup>
defineProps({
  currentLang: {
    type: String,
    required: true,
  },
  langLabel: {
    type: Function,
    required: true,
  },
  supportedLangs: {
    type: Array,
    required: true,
  },
  switchKeyPrefix: {
    type: String,
    default: "",
  },
});

defineEmits(["select"]);
</script>

<template>
  <div class="lang-switch" aria-label="Language">
    <button
      v-for="lang in supportedLangs"
      :key="switchKeyPrefix ? `${switchKeyPrefix}-${lang}` : lang"
      type="button"
      class="lang-btn"
      :class="{ active: currentLang === lang }"
      :aria-pressed="currentLang === lang ? 'true' : 'false'"
      @click="$emit('select', lang)"
    >
      {{ langLabel(lang) }}
    </button>
  </div>
</template>
